export const SsoIdBranding = "Pragmatec ID";
export const AppName = "ID Maker";

export const Role = {
    Admin: "Admin",
    User: "User"
};